declare namespace $ {

	type $mol_view__sub_bog_worm_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_worm_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_search__hint_bog_worm_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_search['hint'] >
	>
	type $mol_search__query_bog_worm_4 = $mol_type_enforce<
		ReturnType< $bog_worm['query'] >
		,
		ReturnType< $mol_search['query'] >
	>
	type $mol_search__suggests_bog_worm_5 = $mol_type_enforce<
		ReturnType< $bog_worm['suggests'] >
		,
		ReturnType< $mol_search['suggests'] >
	>
	type $mol_select__hint_bog_worm_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_select['hint'] >
	>
	type $mol_select__value_bog_worm_7 = $mol_type_enforce<
		ReturnType< $bog_worm['layout_name'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_bog_worm_8 = $mol_type_enforce<
		({ 
			'layered': string,
			'force': string,
		}) 
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_button_minor__hint_bog_worm_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_worm_10 = $mol_type_enforce<
		ReturnType< $bog_worm['reset'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_worm_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_check__title_bog_worm_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check['title'] >
	>
	type $mol_check__hint_bog_worm_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check['hint'] >
	>
	type $mol_check__checked_bog_worm_14 = $mol_type_enforce<
		ReturnType< $bog_worm['panel_showed'] >
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_view__dom_name_bog_worm_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__sub_bog_worm_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_worm_17 = $mol_type_enforce<
		ReturnType< $bog_worm['stage'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__uri_bog_worm_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__external_bog_worm_19 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_link['external'] >
	>
	type $mol_link__title_bog_worm_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_worm_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__external_bog_worm_22 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_link['external'] >
	>
	type $mol_link__title_bog_worm_23 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_worm_24 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__external_bog_worm_25 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_link['external'] >
	>
	type $mol_link__title_bog_worm_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_worm_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__external_bog_worm_28 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_link['external'] >
	>
	type $mol_link__title_bog_worm_29 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_view__dom_name_bog_worm_30 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__sub_bog_worm_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_worm_panel__type_on_bog_worm_32 = $mol_type_enforce<
		ReturnType< $bog_worm['type_on'] >
		,
		ReturnType< $bog_worm_panel['type_on'] >
	>
	type $bog_worm_panel__kind_on_bog_worm_33 = $mol_type_enforce<
		ReturnType< $bog_worm['kind_on'] >
		,
		ReturnType< $bog_worm_panel['kind_on'] >
	>
	type $bog_worm_panel__weight_min_bog_worm_34 = $mol_type_enforce<
		ReturnType< $bog_worm['weight_min'] >
		,
		ReturnType< $bog_worm_panel['weight_min'] >
	>
	type $bog_worm_panel__path_from_bog_worm_35 = $mol_type_enforce<
		ReturnType< $bog_worm['path_from'] >
		,
		ReturnType< $bog_worm_panel['path_from'] >
	>
	type $bog_worm_panel__path_to_bog_worm_36 = $mol_type_enforce<
		ReturnType< $bog_worm['path_to'] >
		,
		ReturnType< $bog_worm_panel['path_to'] >
	>
	type $mol_view__sub_bog_worm_37 = $mol_type_enforce<
		ReturnType< $bog_worm['board'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_worm_plot__layout_name_bog_worm_38 = $mol_type_enforce<
		ReturnType< $bog_worm['layout_name'] >
		,
		ReturnType< $bog_worm_plot['layout_name'] >
	>
	type $bog_worm_plot__types_bog_worm_39 = $mol_type_enforce<
		ReturnType< $bog_worm['types'] >
		,
		ReturnType< $bog_worm_plot['types'] >
	>
	type $bog_worm_plot__kinds_bog_worm_40 = $mol_type_enforce<
		ReturnType< $bog_worm['kinds'] >
		,
		ReturnType< $bog_worm_plot['kinds'] >
	>
	type $bog_worm_plot__weight_min_bog_worm_41 = $mol_type_enforce<
		ReturnType< $bog_worm['weight_min'] >
		,
		ReturnType< $bog_worm_plot['weight_min'] >
	>
	type $bog_worm_plot__focus_bog_worm_42 = $mol_type_enforce<
		ReturnType< $bog_worm['focus'] >
		,
		ReturnType< $bog_worm_plot['focus'] >
	>
	type $bog_worm_plot__path_from_bog_worm_43 = $mol_type_enforce<
		ReturnType< $bog_worm['path_from'] >
		,
		ReturnType< $bog_worm_plot['path_from'] >
	>
	type $bog_worm_plot__path_to_bog_worm_44 = $mol_type_enforce<
		ReturnType< $bog_worm['path_to'] >
		,
		ReturnType< $bog_worm_plot['path_to'] >
	>
	type $mol_view__style_bog_worm_45 = $mol_type_enforce<
		({ 
			'left': ReturnType< $bog_worm['tip_left'] >,
			'top': ReturnType< $bog_worm['tip_top'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_bog_worm_46 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_worm_detail__focus_bog_worm_47 = $mol_type_enforce<
		ReturnType< $bog_worm['focus'] >
		,
		ReturnType< $bog_worm_detail['focus'] >
	>
	export class $bog_worm extends $mol_view {
		panel_state( ): string
		layout_kind( ): string
		Theme( ): $mol_theme_auto
		keyboard( ): any
		brand( ): string
		count( ): string
		Count( ): $mol_view
		Brand( ): $mol_view
		query( next?: string ): string
		suggests( ): readonly(string)[]
		Search( ): $mol_search
		layout_name( next?: string ): string
		Layout( ): $mol_select
		reset( next?: any ): any
		reset_label( ): string
		Reset( ): $mol_button_minor
		panel_showed( next?: boolean ): boolean
		Panel_toggle( ): $mol_check
		Head( ): $mol_view
		stage( ): readonly(any)[]
		Stage( ): $mol_view
		foot_lead( ): string
		Cook( ): $mol_link
		foot_atlas( ): string
		Atlas( ): $mol_link
		foot_openworm( ): string
		Openworm( ): $mol_link
		foot_source( ): string
		Repo( ): $mol_link
		Foot( ): $mol_view
		type_on( id: any, next?: boolean ): boolean
		kind_on( id: any, next?: boolean ): boolean
		weight_min( next?: number ): number
		path_from( next?: string ): string
		path_to( next?: string ): string
		board( ): readonly(any)[]
		types( ): Record<string, any>
		kinds( ): Record<string, any>
		focus( next?: string ): string
		tip_left( ): string
		tip_top( ): string
		tip_text( ): string
		dom_name( ): string
		title( ): string
		hint( ): string
		attr( ): ({ 
			'worm_panel': ReturnType< $bog_worm['panel_state'] >,
			'worm_layout': ReturnType< $bog_worm['layout_kind'] >,
		})  & ReturnType< $mol_view['attr'] >
		plugins( ): readonly(any)[]
		auto( ): readonly(any)[]
		sub( ): readonly(any)[]
		Aside( ): $bog_worm_panel
		Board( ): $mol_view
		Canvas( ): $bog_worm_plot
		Tip( ): $mol_view
		Links( ): $bog_worm_detail
	}
	
}

//# sourceMappingURL=worm.view.tree.d.ts.map